import { useState, useEffect, useRef } from 'react';
import axios from 'axios';

const BASE_URL = process.env.REACT_APP_DATA_ACCESS_BASE_URL;

export default function useBatchStatusApi() {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [result, setResult] = useState(null);

    /*useEffect(() => {
        let timeoutHandle = undefined;
        const executeRequestLoop = () => {
            setLoading(true);
            setError(undefined);
            axios.get(`${BASE_URL}/status/batches`).then(({ data }) => {
                setResult(data);
                timeoutHandle = setTimeout(executeRequestLoop, 20000);
            }).catch(e => {
                setError(e);
                timeoutHandle = setTimeout(executeRequestLoop, 40000);
            }).finally(() => {
                setLoading(false);
            });
        };

        executeRequestLoop();
        return () => {
            if (timeoutHandle) {
                clearTimeout(timeoutHandle);
            }
        }
    }, []);*/

    

    return {
        loading,
        error,
        result
    };
}

